import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  createTimeSheetApi,
  getConfigTimeSheetAPI,
  updateConfigTimeSheetApi,
} from "../../API/API";
import {
  configTimeSheetFailure,
  configTimeSheetSuccess,
  getConfigTimeSheetFailure,
  getConfigTimeSheetSuccess,
} from "../actions";
import { alertNotification } from "./../../components/TopNotification/alertNotification";

function* configTimeSheetSaga(params) {
  try {
    let response = {};
    if (params?.payload?.timeSheetId)
      response = yield call(() => updateConfigTimeSheetApi(params.payload));
    else response = yield call(() => createTimeSheetApi(params.payload));
    if (response?.status == 200 || response?.status == 201) {
      alertNotification("success", response?.data?.data?.message || "Timesheet configured successfully");
      yield put(configTimeSheetSuccess(response));
      if (typeof params?.payload?.callBack === "function") {
        params.payload.callBack();
      }
    } else {
      throw response.message;
    }
  } catch (error) {
    alertNotification(
      "error",
      error?.response?.data?.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong."
    );
    yield put(configTimeSheetFailure(error));
  }
}

function getRequiredResponse(bidData, timeSheetId) {
  return {
    GigId: bidData?._id, // Using the _id field as GigId
    TalentAccountId: bidData?.TalentAccountId,
    BidId: bidData?.BidId,
    StartDate: bidData?.ShiftTime?.StartDate,
    EndDate: bidData?.ShiftTime?.EndDate,
    Period: bidData?.WorkHours?.Period,
    Hours: bidData?.WorkHours?.Hours,
    StartOffsetMs: bidData?.ShiftTime?.StartOffsetMs,
    EndOffsetMs: bidData?.ShiftTime?.EndOffsetMs,
    timeSheetId,
  };
}

function* getConfigTimeSheetSaga(params) {
  try {
    const response = yield call(() => getConfigTimeSheetAPI(params.payload));

    if (response.status == 200 || response.status == 201) {
      yield put(
        getConfigTimeSheetSuccess(
          getRequiredResponse(
            response?.data?.data?.data,
            params?.payload?.configureTimeSheetId
          )
        )
      );
      if (typeof params?.payload?.callBack === "function") {
        params.payload.callBack();
      }
    } else {
      throw response.message;
    }
  } catch (error) {
    alertNotification(
      "error",
      error?.response?.data?.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong."
    );
    yield put(getConfigTimeSheetFailure(error));
  }
}

export function* watchConfigTimeSheetSaga() {
  yield takeEvery(types.CONFIG_TIME_SHEET_REQUESTED, configTimeSheetSaga);
}

export function* watchGetConfigTimeSheetSaga() {
  yield takeEvery(types.GET_CONFIG_TIME_SHEET_INIT, getConfigTimeSheetSaga);
}
